/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _style13 = require('antd/lib/date-picker/style');

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _style14 = require('antd/lib/icon/style');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _style15 = require('antd/lib/col/style');

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _style16 = require('antd/lib/row/style');

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _style17 = require('antd/lib/alert/style');

var _alert = require('antd/lib/alert');

var _alert2 = _interopRequireDefault(_alert);

var _style18 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _style19 = require('antd/lib/select/style');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _style20 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style21 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _style22 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _style23 = require('antd/lib/upload/style');

var _upload = require('antd/lib/upload');

var _upload2 = _interopRequireDefault(_upload);

var _style24 = require('antd/lib/steps/style');

var _steps = require('antd/lib/steps');

var _steps2 = _interopRequireDefault(_steps);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _template = require('../../../common/template');

var _template2 = _interopRequireDefault(_template);

var _wc = require('./wc2.png');

var _wc2 = _interopRequireDefault(_wc);

var _config = require('util/config');

var _tool = require('util/tool');

var _premissionAuth = require('util/premissionAuth');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Step = _steps2.default.Step;

var Dragger = _upload2.default.Dragger;


var FormItem = _form2.default.Item;
var TextArea = _input2.default.TextArea;

var _ref = (0, _jsx3.default)(Step, {
    title: '\u5347\u7EA7\u5305\u57FA\u7840\u4FE1\u606F'
});

var _ref2 = (0, _jsx3.default)(Step, {
    title: '\u5347\u7EA7\u5305\u8BE6\u7EC6\u4FE1\u606F'
});

var _ref3 = (0, _jsx3.default)(Step, {
    title: '\u5B8C\u6210'
});

var _ref4 = (0, _jsx3.default)('div', {
    className: 'ant-upload-drag-warp'
}, void 0, (0, _jsx3.default)('p', {
    className: 'ant-upload-drag-icon'
}, void 0, (0, _jsx3.default)(_icon2.default, {
    type: 'cloud-upload'
})), (0, _jsx3.default)('p', {
    className: 'ant-upload-text'
}, void 0, '\u70B9\u51FB\u4E0A\u4F20\u5347\u7EA7\u5305'));

var _ref5 = (0, _jsx3.default)(_input2.default, {
    placeholder: '\u8BF7\u8F93\u5165\u5347\u7EA7\u7248\u672C\u53F7\uFF01'
});

var _ref6 = (0, _jsx3.default)(_input2.default, {
    placeholder: '\u8BF7\u8F93\u5165\u5916\u90E8\u7248\u672C\u53F7\uFF01'
});

var _ref7 = (0, _jsx3.default)(_input2.default, {
    placeholder: '\u8BF7\u8F93\u5165\u5916\u90E8\u7248\u672C\u7B80\u4ECB'
});

var _ref8 = (0, _jsx3.default)(_datePicker2.default, {
    placeholder: '\u8BF7\u9009\u62E9\u65F6\u95F4\uFF01'
});

var _ref9 = (0, _jsx3.default)(_icon2.default, {
    type: 'plus'
});

var _ref10 = (0, _jsx3.default)(Option, {
    value: 0
}, void 0, 'VCU');

var _ref11 = (0, _jsx3.default)(Option, {
    value: 1
}, void 0, 'BMS');

var _ref12 = (0, _jsx3.default)(Option, {
    value: 2
}, void 0, 'MCCU');

var _ref13 = (0, _jsx3.default)(Option, {
    value: 3
}, void 0, 'ICM');

var _ref14 = (0, _jsx3.default)(Option, {
    value: 4
}, void 0, 'CP');

var _ref15 = (0, _jsx3.default)(Option, {
    value: 5
}, void 0, 'MP');

var _ref16 = (0, _jsx3.default)(Option, {
    value: 6
}, void 0, 'BOXBMS');

var _ref17 = (0, _jsx3.default)(Option, {
    value: 7
}, void 0, '\u5176\u4ED6');

var _ref18 = (0, _jsx3.default)(_button2.default, {
    type: 'primary',
    htmlType: 'submit'
}, void 0, '\u63D0\u4EA4');

var _ref19 = (0, _jsx3.default)('img', {
    src: _wc2.default,
    alt: ''
});

var Main = function (_Component) {
    (0, _inherits3.default)(Main, _Component);

    function Main(props, context) {
        (0, _classCallCheck3.default)(this, Main);

        //console.log(this.props)
        var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

        _this.handleChange = function (info) {
            console.log(info, '2');
            // return false;
            if (info.fileList.length === 1) {
                if (info.file.status == "done") {
                    var res = info.file.response;
                    if (res && res.status == 1) {

                        var sendData = {
                            id: res.data[0]
                        };
                        _this.setState({
                            id: sendData.id,
                            names: info.file.name,
                            displayName: 'none'
                        });
                        _this.getPackageName(sendData);
                    } else {
                        console.log(res);
                        _this.setState({
                            docJudge: true
                        });
                        _message2.default.error(res ? res.message : "上传失败");
                    }
                }
            } else {
                // Message.error("只能上传一个文件");
            }
        };

        _this.onRemove = function (file) {
            console.log(file);
            if (file.status == "removed") {
                _this.setState({
                    packageName: '',
                    id: '',
                    displayName: 'inline',
                    docJudge: false,
                    upStatus: true,
                    defaultFileList: []
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            if (_this.state.ruleVal.length <= 0) {
                _this.setState({
                    ruleStatus: true
                });
            }
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    console.log('Received values of form: ', values);
                    if (!_this.state.id) {
                        _message2.default.warning('请上传升级包');
                        return false;
                    }
                    var sendData = {
                        productId: _this.props.params.id,
                        packageId: _this.state.id,
                        packageName: _this.state.packageName,
                        fileOriginName: _this.state.names,
                        packageVerifyValue: 'M6-123',
                        remark: values.remark,
                        versionCode: values.versionCode,
                        versionName: 'M6',
                        status: _this.state.currentVersion,
                        packageType: values.sjType
                    };
                    console.log(sendData, 'wokankan');
                    _this.setState({
                        upgradeData: sendData,
                        nextNum: 1
                    });
                    // http(apiJson.insertVersion,sendData).then(res => {
                    //     if(res == true){
                    //         Message.success('新增升级包成功！')
                    //         setTimeout(() => {
                    //             let {id} = this.props.params
                    //             this.props.router.push({
                    //                 pathname: `/version/index/${id}`
                    //             })
                    //         }, 500)
                    //     }
                    // })
                }
            });
        };

        _this.nextStep = function () {
            _this.setState({
                nextNum: 1
            });
        };

        _this.previousStep = function () {
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    // console.log(values, 'hahah')
                    _this.setState({
                        outData: values
                    });
                }
            });
            var upgradeData = _this.state.upgradeData;

            if (upgradeData.fileOriginName) {
                var defaultFileList = [{
                    uid: -1,
                    status: 'done',
                    name: upgradeData.fileOriginName
                }];
                _this.setState({
                    nextNum: 0,
                    upStatus: false,
                    defaultFileList: defaultFileList
                });
            } else {
                _this.setState({
                    nextNum: 0,
                    upStatus: true
                });
            }
        };

        _this.handleSubmitTwo = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    if (!values.outVersion) {
                        _message2.default.warning('请输入外部版本号');
                        return false;
                    }
                    if (!values.outVersionNote) {
                        _message2.default.warning('请输入外部版本简介');
                        return false;
                    }
                    if (!values.remark2) {
                        _message2.default.warning('请输入外部版本更新说明');
                        return false;
                    }
                    if (!values.sendTime) {
                        _message2.default.warning('请选择正式发布时间');
                        return false;
                    }
                    if (_this.state.ruleVal.length <= 0) {
                        _message2.default.warning('请至少输入一个版本详情');
                        return false;
                    }
                    var tem = {
                        '0': 'VCU',
                        '1': 'BMS',
                        '2': 'MCCU',
                        '3': 'ICM',
                        '4': 'CP',
                        '5': 'MP',
                        '6': 'BOXBMS',
                        '7': '其他'
                    };
                    var data = _this.state.ruleVal.map(function (item) {
                        if (item.componentType == 7) {
                            return (item.operator ? item.operator : '') + ' ' + (item.partFirmwareVersion ? item.partFirmwareVersion : '');
                        } else {
                            return (tem[item.componentType] ? tem[item.componentType] : '') + ' ' + (item.partFirmwareVersion ? item.partFirmwareVersion : '');
                        }
                    });
                    var infoDate = {
                        outVersion: values.outVersion,
                        outVersionNote: values.outVersionNote,
                        remark: values.remark2,
                        sendTime: values.sendTime,
                        influencedPartVersion: (0, _stringify2.default)(data)
                    };
                    var a = (0, _extends3.default)({}, _this.state.upgradeData, {
                        baseVersionDetailRequest: infoDate,
                        detailFlag: 1
                    });
                    (0, _tool.http)(_config.apiJson.insertVersion, a).then(function (res) {
                        if (res == true) {
                            _message2.default.success('新增升级包成功！');
                            _this.setState({
                                nextNum: 2
                            });
                            setTimeout(function () {
                                var id = _this.props.params.id;

                                _this.props.router.push({
                                    pathname: '/version/index/' + id
                                });
                            }, 3000);
                        }
                    });
                }
            });
        };

        _this.skipSubmit = function () {
            var a = (0, _extends3.default)({}, _this.state.upgradeData, {
                // baseVersionDetailRequest: infoDate,
                detailFlag: 0
            });
            (0, _tool.http)(_config.apiJson.insertVersion, a).then(function (res) {
                if (res == true) {
                    _message2.default.success('新增升级包成功！');
                    _this.setState({
                        nextNum: 2
                    });
                    setTimeout(function () {
                        var id = _this.props.params.id;

                        _this.props.router.push({
                            pathname: '/version/index/' + id
                        });
                    }, 5000);
                }
            });
        };

        _this.handleClose = function () {
            _this.setState({
                visible: false
            });
        };

        _this.state = {
            id: '',
            packageName: '',
            names: '',
            num: 0,
            fileList: [],
            displayName: 'inline',
            docJudge: false,
            vList: [{ key: '1', value: '研发版本' }, { key: '2', value: '测试版本' }, { key: '3', value: '发布版本' }],
            sjblx: [{ key: '1', value: '车辆升级包' }, { key: '2', value: '通讯模块升级包' }],
            sjType: '1',
            currentVersion: null,
            nextNum: 0,
            ruleVal: [],
            visible: true,
            upgradeData: {},
            defaultFileList: [],
            upStatus: true,
            ruleStatus: false,
            outData: {}
        };
        return _this;
    }

    (0, _createClass3.default)(Main, [{
        key: 'fileUrlToName',
        value: function fileUrlToName(url) {
            var array = url.split("/");
            if (array.length > 1) {
                return array[array.length - 1];
            } else {
                return '';
            }
        }
    }, {
        key: 'handleStatusChange',
        value: function handleStatusChange(value) {
            console.log('修改状态', value);
            this.setState({
                currentVersion: value
            });
        }
    }, {
        key: 'handleTypeChange',
        value: function handleTypeChange(value) {
            this.setState({
                sjType: value
            });
            console.log(value, '-----------');
        }
    }, {
        key: 'getPackageName',
        value: function getPackageName(data) {
            var _this2 = this;

            (0, _tool.http)(_config.apiJson.getResource, data).then(function (res) {
                var fileUrl = res.fileUrl;
                var packageName = _this2.fileUrlToName(fileUrl);
                _this2.setState({
                    packageName: packageName
                });
            });
        }
    }, {
        key: 'returnList',
        value: function returnList() {
            var id = this.props.params.id;

            this.props.router.push({
                pathname: '/version/index/' + id
            });
        }
    }, {
        key: 'clickChange',
        value: function clickChange() {
            var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
            a.push({
                componentType: 0,
                operator: '',
                partFirmwareVersion: null
            });
            if (a.length > 4) return;
            this.setState({
                ruleVal: a
            });
        }
    }, {
        key: 'handleChangeType',
        value: function handleChangeType(i, val) {
            var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
            a[i].componentType = val;
            this.setState({
                ruleVal: a
            });
        }
    }, {
        key: 'handleChangeStatus',
        value: function handleChangeStatus(i, val) {
            var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
            a[i].operator = val.target.value;
            this.setState({
                ruleVal: a
            });
        }
    }, {
        key: 'handleChangeVal',
        value: function handleChangeVal(i, val) {
            var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
            a[i].partFirmwareVersion = val.target.value;
            this.setState({
                ruleVal: a
            });
        }
    }, {
        key: 'sc',
        value: function sc(i) {
            var copy = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
            copy.splice(i, 1);
            this.setState({
                ruleVal: copy
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var getFieldDecorator = this.props.form.getFieldDecorator;
            var _state = this.state,
                packageName = _state.packageName,
                fileList = _state.fileList,
                displayName = _state.displayName,
                vList = _state.vList,
                sjblx = _state.sjblx,
                nextNum = _state.nextNum,
                visible = _state.visible,
                defaultFileList = _state.defaultFileList,
                upgradeData = _state.upgradeData,
                upStatus = _state.upStatus,
                outData = _state.outData;

            var formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 14 }
            };

            var UploadData = {
                businessType: 'DEVICE_UPGRADE_PACKAGE'
            };
            var token = localStorage.getItem("token");
            var ctoken = (0, _premissionAuth.getToken)();

            var headers = {
                Token: ctoken ? ctoken : token
            };

            return (0, _jsx3.default)('div', {
                className: 'version-insert'
            }, void 0, (0, _jsx3.default)('div', {
                className: 'insert-top'
            }, void 0, (0, _jsx3.default)(_steps2.default, {
                size: 'default',
                current: nextNum
            }, void 0, _ref, _ref2, _ref3)), nextNum === 0 ? (0, _jsx3.default)(_form2.default, {
                onSubmit: this.handleSubmit
            }, void 0, _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u5347\u7EA7\u5305'
                }),
                (0, _jsx3.default)('div', {
                    className: 'dropbox'
                }, void 0, getFieldDecorator('file', {
                    rules: [{ required: upStatus, message: '请上传升级包' }]
                    //initialValue:`${initInfo.pictureId}`
                })((0, _jsx3.default)(Dragger, {
                    action: _config.target + _config.apiJson.upload,
                    data: UploadData,
                    headers: headers,
                    onChange: this.handleChange,
                    onRemove: this.onRemove,
                    style: { display: displayName },
                    defaultFileList: defaultFileList
                }, void 0, _ref4)))
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u5347\u7EA7\u7248\u672C\u53F7'
                }),
                getFieldDecorator('versionCode', {
                    rules: [{ required: true, message: '请输入升级版本号！' }],
                    initialValue: upgradeData.versionCode
                })(_ref5)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u7248\u672C\u8981\u70B9'
                }),
                getFieldDecorator('remark', {
                    rules: [{ required: true, message: '请输入版本要点！' }],
                    initialValue: upgradeData.remark
                })((0, _jsx3.default)(TextArea, {
                    style: { height: "124px" },
                    placeholder: '\u8BF7\u8F93\u5165\u7248\u672C\u8981\u70B9\uFF01'
                }))
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u7248\u672C\u72B6\u6001'
                }),
                getFieldDecorator('ok', {
                    rules: [{ required: true, message: '请输入版本要点！' }],
                    initialValue: upgradeData.status
                })((0, _jsx3.default)(_select2.default, {
                    style: { width: 200 },
                    onChange: this.handleStatusChange.bind(this)
                }, void 0, vList.map(function (item, index) {
                    return (0, _jsx3.default)(Option, {
                        value: item.key
                    }, index, item.value);
                })))
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u5347\u7EA7\u5305\u7C7B\u578B'
                }),
                getFieldDecorator('sjType', {
                    rules: [{ required: true, message: '请输入升级包类型' }],
                    initialValue: this.state.sjType
                })((0, _jsx3.default)(_select2.default, {
                    style: { width: 200 },
                    onChange: this.handleTypeChange.bind(this)
                }, void 0, sjblx.map(function (item, index) {
                    return (0, _jsx3.default)(Option, {
                        value: item.key
                    }, index, item.value);
                })))
            ), (0, _jsx3.default)(FormItem, {
                wrapperCol: { span: 12, offset: 6 }
            }, void 0, (0, _jsx3.default)(_button2.default, {
                type: 'primary',
                htmlType: 'submit',
                disabled: this.state.docJudge
            }, void 0, '\u4E0B\u4E00\u6B65'), (0, _jsx3.default)(_button2.default, {
                onClick: this.returnList.bind(this)
            }, void 0, '\u53D6\u6D88'))) : null, nextNum === 1 ? (0, _jsx3.default)(_form2.default, {
                onSubmit: this.handleSubmitTwo
            }, void 0, visible ? (0, _jsx3.default)(_alert2.default, {
                message: '\u4FE1\u606F\u76F4\u63A5\u5448\u73B0\u5728\u7528\u6237App\u7AEF\uFF0C\u8BF7\u8BA4\u771F\u586B\u5199\u3002',
                type: 'info',
                style: { marginBottom: 20, marginLeft: 70, width: '80%' },
                closable: true,
                afterClose: this.handleClose
            }) : null, _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u5916\u90E8\u7248\u672C\u53F7(app\u5C55\u793A)'
                }),
                getFieldDecorator('outVersion', {
                    rules: [{ required: false, message: '请输入外部版本号！' }],
                    initialValue: outData.outVersion
                })(_ref6)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u5916\u90E8\u7248\u672C\u7B80\u4ECB(app\u5C55\u793A)'
                }),
                getFieldDecorator('outVersionNote', {
                    rules: [{ required: false, message: '请输入外部版本简介！' }],
                    initialValue: outData.outVersionNote
                })(_ref7)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u5916\u90E8\u7248\u672C\u66F4\u65B0\u8BF4\u660E(app\u5C55\u793A)'
                }),
                getFieldDecorator('remark2', {
                    rules: [{ required: false, message: '请输入外部版本更新说明' }],
                    initialValue: outData.remark2
                })(
                // style={{height:"124px"}}
                (0, _jsx3.default)(TextArea, {
                    placeholder: '\u8BF7\u8F93\u5165\u5916\u90E8\u7248\u672C\u66F4\u65B0\u8BF4\u660E',
                    style: { 'minHeight': "124px" },
                    autoSize: true
                }))
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u6B63\u5F0F\u53D1\u5E03\u65F6\u95F4'
                }),
                getFieldDecorator('sendTime', {
                    rules: [{ required: false, message: '请选择时间！' }],
                    initialValue: outData.sendTime
                })(_ref8)
            ), _react2.default.createElement(
                FormItem,
                (0, _extends3.default)({}, formItemLayout, {
                    label: '\u7248\u672C\u8BE6\u60C5'
                }),
                getFieldDecorator('influencedPartVersion', {
                    rules: [{ required: false, message: '请选择一个版本详情！' }]
                })((0, _jsx3.default)(_button2.default, {
                    type: 'dashed',
                    onClick: this.clickChange.bind(this),
                    style: { width: "100%" }
                }, void 0, _ref9, ' \u6DFB\u52A0'))
            ), this.state.ruleVal.map(function (item, index) {
                return (0, _jsx3.default)(_row2.default, {
                    style: { marginBottom: 20, paddingLeft: '15%' }
                }, void 0, (0, _jsx3.default)(_col2.default, {
                    span: 7
                }, void 0, (0, _jsx3.default)('span', {
                    style: { fontSize: 14 }
                }, void 0, '\u90E8\u4EF6\u7C7B\u578B\uFF1A'), (0, _jsx3.default)(_select2.default, {
                    value: item.componentType,
                    onChange: _this3.handleChangeType.bind(_this3, index),
                    style: { width: 100 }
                }, void 0, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17)), (0, _jsx3.default)(_col2.default, {
                    span: 4
                }, void 0, item.componentType == 7 ? (0, _jsx3.default)(_input2.default, {
                    value: item.operator,
                    onChange: _this3.handleChangeStatus.bind(_this3, index),
                    placeholder: '\u56FA\u4EF6\u7C7B\u578B',
                    style: { width: 100 }
                }) : ''), (0, _jsx3.default)(_col2.default, {
                    span: 6
                }, void 0, (0, _jsx3.default)('span', {
                    style: { fontSize: 14 }
                }, void 0, '\u7248\u672C\uFF1A'), (0, _jsx3.default)(_input2.default, {
                    value: item.partFirmwareVersion,
                    onChange: _this3.handleChangeVal.bind(_this3, index),
                    style: { width: 100 }
                })), (0, _jsx3.default)(_col2.default, {
                    style: { lineHeight: '36px', color: '#3296FA' },
                    span: 2
                }, void 0, (0, _jsx3.default)('span', {
                    onClick: _this3.sc.bind(_this3, index),
                    style: { cursor: 'pointer' }
                }, void 0, '\u5220\u9664')));
            }), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('p', {
                style: { fontSize: 14, color: '#bbb' }
            }, void 0, '\u8BF4\u660E'), (0, _jsx3.default)('p', {
                style: { fontSize: 12, color: '#bbb' }
            }, void 0, '\u5347\u7EA7\u5305\u8BE6\u7EC6\u4FE1\u606F\u7528\u4E8E\u76F4\u63A5\u5448\u73B0\u7ED9\u7528\u6237APP\u7AEF\uFF0C\u4FE1\u606F\u53EF\u4E0D\u586B\u5199\u3002\u5982\u679C\u4E0D\u586B\u5199\uFF0C\u5219\u8BE5\u5305\u7684\u5347\u7EA7\u8BB0\u5F55\u4E0D\u4F1A\u663E\u793A\u5728\u5347\u7EA7\u8BB0\u5F55\u5217\u8868\u4E2D\uFF0C\u540C\u65F6\u4E0D\u4F1A\u628A\u5347\u7EA7\u72B6\u6001\u63A8\u9001\u7ED9\u7528\u6237\u3002')), (0, _jsx3.default)(FormItem, {
                wrapperCol: { span: 12, offset: 6 }
            }, void 0, _ref18, (0, _jsx3.default)(_button2.default, {
                type: 'primary',
                onClick: this.skipSubmit
            }, void 0, '\u8DF3\u8FC7\u5E76\u63D0\u4EA4'), (0, _jsx3.default)(_button2.default, {
                onClick: this.previousStep
            }, void 0, '\u4E0A\u4E00\u6B65'))) : null, nextNum === 2 ? (0, _jsx3.default)('div', {
                className: 'add-complete'
            }, void 0, (0, _jsx3.default)('div', {}, void 0, _ref19, (0, _jsx3.default)('div', {
                style: { textAlign: 'center', fontSize: 15 }
            }, void 0, '\u5B8C\u6210'))) : null);
        }
    }]);
    return Main;
}(_react.Component);

var InsertVersion = _form2.default.create()(Main);

exports.default = (0, _template2.default)({
    id: '', // 应用关联使用的redux
    component: InsertVersion, // 接收数据的组件入口
    url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/version/insert/index.jsx
// module id = 1530
// module chunks = 0